export var precisionMath = function precisionMath(value) {
  return parseFloat(value.toFixed(10));
};
export var checkValue = function checkValue(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Slider/utils.js
// module id = 577
// module chunks = 35